// Compiler result to JSON file
import { createComponent } from 'js/declViewModelService';
import { registerDynImportEntry } from 'js/moduleLoader';
import AwParseService from 'js/awParseService';
import AwFilterService from 'js/awFilterService';
import { getField } from 'js/utils';
import { Fragment } from 'react';
let filterSer = AwFilterService.instance;
import AwPanel from 'viewmodel/AwPanelViewModel';
import DesCreateTeamMainPanel from 'viewmodel/DesCreateTeamMainPanelViewModel';
import DesCreateTeamSubPanel from 'viewmodel/DesCreateTeamSubPanelViewModel';
import { ShowWhen } from 'js/hocCollection';
const DesCreateTeamMainPanelShowWhen = ShowWhen(DesCreateTeamMainPanel);
const DesCreateTeamSubPanelShowWhen = ShowWhen(DesCreateTeamSubPanel);
DesCreateTeamMainPanelShowWhen.displayName = 'DesCreateTeamMainPanelShowWhen';
DesCreateTeamSubPanelShowWhen.displayName = 'DesCreateTeamSubPanelShowWhen';

/*
ctx imports
*/

const ctxImportObj = {};

/*
dynamic import
 */
registerDynImportEntry('js/DesTeamMembersService', () => import('js/DesTeamMembersService'));
;

/*
view model
 */
const declViewModelJson = {
  "schemaVersion": "1.0.0",
  "lifecycleHooks": {
    "onUnmount": "resetActiveView",
    "onUpdate": {
      "observers": ["props.accsessionid", "props.collaborationspaceid"]
    }
  },
  "data": {
    "sharedData": {
      "initialValues": {
        "activeView": "createTeamMainPanel",
        "panelView": "createTeamMainPanel",
        "existingMembers": false
      },
      "meta": {}
    }
  },
  "props": {
    "accsessionid": {
      "type": "string"
    },
    "collaborationspaceid": {
      "type": "string"
    }
  },
  "actions": {
    "resetActiveView": {
      "actionType": "JSFunction",
      "method": "resetPanelCreateTeam",
      "inputData": {
        "sharedData": "{{data.sharedData}}"
      },
      "outputData": {
        "sharedData": ""
      },
      "deps": "js/DesTeamMembersService"
    },
    "backAction": {
      "actionType": "JSFunction",
      "method": "backActionCreateTeam",
      "inputData": {
        "sharedData": "{{data.sharedData}}"
      },
      "outputData": {
        "sharedData": ""
      },
      "deps": "js/DesTeamMembersService"
    }
  },
  "conditions": {
    "enableCreateTeamButton": {
      "expression": "data.teamName.dbValue && data.teamDescription.dbValue"
    }
  },
  "onEvent": [{
    "eventId": "backButtonClicked",
    "action": "backAction"
  }],
  "i18n": {},
  "messages": {},
  "_viewModelId": "DesCollabCreateTeam",
  "_uniqueViewModelId": "DesCollabCreateTeam",
  "ctx": {}
};

/*
<aw-panel>
    <des-create-team-main-panel show-when="data.sharedData.activeView === 'createTeamMainPanel'"
        sub-panel-context='{sharedData:data.sharedData}' accsessionid={{props.accsessionid}}
        collaborationspaceid={{props.collaborationspaceid}}>
    </des-create-team-main-panel>
    <des-create-team-sub-panel show-when="data.sharedData.activeView === 'createTeamSubPanel'"
        sub-panel-context='{sharedData:data.sharedData}' accsessionid={{props.accsessionid}}
        collaborationspaceid={{props.collaborationspaceid}}>
    </des-create-team-sub-panel>
</aw-panel>
*/
const renderFn = props => {
  let subPanelContext = props.subPanelContext;
  let {
    viewModel: {
      data,
      dataProviders,
      dispatch,
      conditions,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    },
    grids,
    ctx,
    actions,
    fields,
    messages,
    i18n,
    formProp,
    viewPath
  } = props;
  data = {
    ...data,
    dataProviders
  };
  if (subPanelContext && subPanelContext.fields) {
    fields = {
      ...fields,
      ...subPanelContext.fields
    };
  }
  let $index = null;
  return /*#__PURE__*/React.createElement(AwPanel, {
    revealAction: actions.reveal
  }, /*#__PURE__*/React.createElement(DesCreateTeamMainPanelShowWhen, {
    subPanelContext: AwParseService.instance("{sharedData:fields.sharedData}")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    accsessionid: AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    collaborationspaceid: AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    showWhen: AwParseService.instance("fields.sharedData.activeView === 'createTeamMainPanel'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }), /*#__PURE__*/React.createElement(DesCreateTeamSubPanelShowWhen, {
    subPanelContext: AwParseService.instance("{sharedData:fields.sharedData}")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    accsessionid: AwParseService.instance("props.accsessionid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    collaborationspaceid: AwParseService.instance("props.collaborationspaceid")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    }),
    showWhen: AwParseService.instance("fields.sharedData.activeView === 'createTeamSubPanel'")({
      props,
      data,
      fields,
      dataProviders,
      ctx,
      i18n,
      actions,
      subPanelContext,
      viewPath,
      conditions,
      formProp,
      dispatch,
      selectionModels,
      editHandlers,
      chartProviders,
      ports
    })
  }));
};

/*
define component
*/
const Component = createComponent(declViewModelJson, renderFn, undefined, ctxImportObj);
export default Component;